import _defineProperty from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["flushMinDelay", "flushMaxDelay", "initialFlushDelay", "stickySession", "useCompression", "sessionSampleRate", "errorSampleRate", "maskAllText", "maskTextSelector", "maskAllInputs", "blockAllMedia", "_experiments", "blockClass", "ignoreClass", "maskTextClass", "blockSelector"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getCurrentHub } from '@sentry/core';
import { DEFAULT_SESSION_SAMPLE_RATE, DEFAULT_ERROR_SAMPLE_RATE, MASK_ALL_TEXT_SELECTOR, DEFAULT_FLUSH_MIN_DELAY, DEFAULT_FLUSH_MAX_DELAY, INITIAL_FLUSH_DELAY } from './constants.js';
import { ReplayContainer } from './replay.js';
import { isBrowser } from './util/isBrowser.js';
var MEDIA_SELECTORS = 'img,image,svg,path,rect,area,video,object,picture,embed,map,audio';
var _initialized = false;

var Replay = /*#__PURE__*/function () {
  function Replay() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$flushMinDelay = _ref.flushMinDelay,
        flushMinDelay = _ref$flushMinDelay === void 0 ? DEFAULT_FLUSH_MIN_DELAY : _ref$flushMinDelay,
        _ref$flushMaxDelay = _ref.flushMaxDelay,
        flushMaxDelay = _ref$flushMaxDelay === void 0 ? DEFAULT_FLUSH_MAX_DELAY : _ref$flushMaxDelay,
        _ref$initialFlushDela = _ref.initialFlushDelay,
        initialFlushDelay = _ref$initialFlushDela === void 0 ? INITIAL_FLUSH_DELAY : _ref$initialFlushDela,
        _ref$stickySession = _ref.stickySession,
        stickySession = _ref$stickySession === void 0 ? true : _ref$stickySession,
        _ref$useCompression = _ref.useCompression,
        useCompression = _ref$useCompression === void 0 ? true : _ref$useCompression,
        sessionSampleRate = _ref.sessionSampleRate,
        errorSampleRate = _ref.errorSampleRate,
        maskAllText = _ref.maskAllText,
        maskTextSelector = _ref.maskTextSelector,
        _ref$maskAllInputs = _ref.maskAllInputs,
        maskAllInputs = _ref$maskAllInputs === void 0 ? true : _ref$maskAllInputs,
        _ref$blockAllMedia = _ref.blockAllMedia,
        blockAllMedia = _ref$blockAllMedia === void 0 ? true : _ref$blockAllMedia,
        _ref$_experiments = _ref._experiments,
        _experiments = _ref$_experiments === void 0 ? {} : _ref$_experiments,
        _ref$blockClass = _ref.blockClass,
        blockClass = _ref$blockClass === void 0 ? 'sentry-block' : _ref$blockClass,
        _ref$ignoreClass = _ref.ignoreClass,
        ignoreClass = _ref$ignoreClass === void 0 ? 'sentry-ignore' : _ref$ignoreClass,
        _ref$maskTextClass = _ref.maskTextClass,
        maskTextClass = _ref$maskTextClass === void 0 ? 'sentry-mask' : _ref$maskTextClass,
        _ref$blockSelector = _ref.blockSelector,
        blockSelector = _ref$blockSelector === void 0 ? '[data-sentry-block]' : _ref$blockSelector,
        recordingOptions = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, Replay);

    ;

    Replay.prototype.__init.call(this);

    this.recordingOptions = _objectSpread({
      maskAllInputs: maskAllInputs,
      blockClass: blockClass,
      ignoreClass: ignoreClass,
      maskTextClass: maskTextClass,
      maskTextSelector: maskTextSelector,
      blockSelector: blockSelector
    }, recordingOptions);
    this.options = {
      flushMinDelay: flushMinDelay,
      flushMaxDelay: flushMaxDelay,
      stickySession: stickySession,
      initialFlushDelay: initialFlushDelay,
      sessionSampleRate: DEFAULT_SESSION_SAMPLE_RATE,
      errorSampleRate: DEFAULT_ERROR_SAMPLE_RATE,
      useCompression: useCompression,
      maskAllText: typeof maskAllText === 'boolean' ? maskAllText : !maskTextSelector,
      blockAllMedia: blockAllMedia,
      _experiments: _experiments
    };

    if (typeof sessionSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn("[Replay] You are passing `sessionSampleRate` to the Replay integration.\nThis option is deprecated and will be removed soon.\nInstead, configure `replaysSessionSampleRate` directly in the SDK init options, e.g.:\nSentry.init({ replaysSessionSampleRate: ".concat(sessionSampleRate, " })"));
      this.options.sessionSampleRate = sessionSampleRate;
    }

    if (typeof errorSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn("[Replay] You are passing `errorSampleRate` to the Replay integration.\nThis option is deprecated and will be removed soon.\nInstead, configure `replaysOnErrorSampleRate` directly in the SDK init options, e.g.:\nSentry.init({ replaysOnErrorSampleRate: ".concat(errorSampleRate, " })"));
      this.options.errorSampleRate = errorSampleRate;
    }

    if (this.options.maskAllText) {
      // `maskAllText` is a more user friendly option to configure
      // `maskTextSelector`. This means that all nodes will have their text
      // content masked.
      this.recordingOptions.maskTextSelector = MASK_ALL_TEXT_SELECTOR;
    }

    if (this.options.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this.recordingOptions.blockSelector = !this.recordingOptions.blockSelector ? MEDIA_SELECTORS : "".concat(this.recordingOptions.blockSelector, ",").concat(MEDIA_SELECTORS);
    }

    if (isBrowser() && this._isInitialized) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }

    this._isInitialized = true;
  }
  /**
   * We previously used to create a transaction in `setupOnce` and it would
   * potentially create a transaction before some native SDK integrations have run
   * and applied their own global event processor. An example is:
   * https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
   *
   * So we call `replay.setup` in next event loop as a workaround to wait for other
   * global event processors to finish. This is no longer needed, but keeping it
   * here to avoid any future issues.
   */


  _createClass(Replay, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Replay.id;
    }
    /**
     * Options to pass to `rrweb.record()`
     */

  }, {
    key: "_isInitialized",
    get: function get() {
      return _initialized;
    },
    set: function set(value) {
      _initialized = value;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      var _this = this;

      if (!isBrowser()) {
        return;
      }

      this._setup(); // XXX: See method comments above


      setTimeout(function () {
        return _this.start();
      });
    }
    /**
     * Initializes the plugin.
     *
     * Creates or loads a session, attaches listeners to varying events (DOM,
     * PerformanceObserver, Recording, Sentry SDK, etc)
     */

  }, {
    key: "start",
    value: function start() {
      if (!this._replay) {
        return;
      }

      this._replay.start();
    }
    /**
     * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
     * does not support a teardown
     */

  }, {
    key: "stop",
    value: function stop() {
      if (!this._replay) {
        return;
      }

      this._replay.stop();
    }
  }, {
    key: "_setup",
    value: function _setup() {
      // Client is not available in constructor, so we need to wait until setupOnce
      this._loadReplayOptionsFromClient();

      this._replay = new ReplayContainer({
        options: this.options,
        recordingOptions: this.recordingOptions
      });
    }
    /** Parse Replay-related options from SDK options */

  }, {
    key: "_loadReplayOptionsFromClient",
    value: function _loadReplayOptionsFromClient() {
      var client = getCurrentHub().getClient();
      var opt = client && client.getOptions();

      if (opt && typeof opt.replaysSessionSampleRate === 'number') {
        this.options.sessionSampleRate = opt.replaysSessionSampleRate;
      }

      if (opt && typeof opt.replaysOnErrorSampleRate === 'number') {
        this.options.errorSampleRate = opt.replaysOnErrorSampleRate;
      }
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Replay';
    }
  }]);

  return Replay;
}();

Replay.__initStatic();

export { Replay };